import { updateLocale } from 'moment'
import 'moment/locale/en-gb'
updateLocale('en', {
  week: {
    dow: 1, // First day of week is Monday
  },
})
